import React, { useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  Button,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material'

import imgBarcode from '../../assets/icons/barcode.svg'
import { useAppStore } from '../../store/useAppStore'
import { useTranslation } from 'react-i18next'

const AddVehicleIdDialog = () => {
  const isAddVehicleIdDialogVisible = useAppStore(
    (state) => state.isAddVehicleIdDialogVisible
  )
  const setIsAddVehicleIdDialogVisible = useAppStore(
    (state) => state.setIsAddVehicleIdDialogVisible
  )
  const setVehicleId = useAppStore((state) => state.setVehicleId)

  const { t } = useTranslation()

  const [plateNum, setPlateNum] = useState('')

  const handleAddVehicleIdDialogClose = () =>
    setIsAddVehicleIdDialogVisible(false)

  const handleAddVehicleIdDialogConfirmation = async () => {
    setVehicleId(plateNum)
    handleAddVehicleIdDialogClose()
  }

  return (
    <Dialog
      open={isAddVehicleIdDialogVisible}
      onClose={handleAddVehicleIdDialogClose}
      className="over-snackbar"
      PaperProps={{
        sx: {
          width: '90%',
          maxWidth: 280,
          margin: (theme) => theme.spacing(5),
        },
      }}
    >
      <Box
        sx={{
          padding: (theme) => theme.spacing(3, 3, 1, 3),
        }}
      >
        <Typography
          variant="h6"
          component="span"
          sx={{
            fontSize: '1.125rem',
            lineHeight: '1.3125rem',
          }}
        >
          {t('add_vehicle_id.enter_plate_license_number')}
        </Typography>
      </Box>
      <DialogContent
        sx={{
          paddingBottom: (theme) => theme.spacing(3),
        }}
      >
        <Typography
          variant={'body1'}
          sx={{
            letterSpacing: 'normal',
          }}
          component="span"
        >
          <TextField
            variant="outlined"
            placeholder={t('add_vehicle_id.plate_license_number')}
            fullWidth
            sx={(theme) => ({
              '& fieldset': {
                borderColor: '#f1f1f1',
              },
              '& .MuiInputBase-root': {
                backgroundColor: '#F1F1F1',
              },
              '& .MuiOutlinedInput-adornedEnd': {
                paddingRight: theme.spacing(1),
              },
            })}
            value={plateNum}
            inputRef={(el) => el?.focus()}
            onChange={(e) => {
              setPlateNum(e.target.value)
            }}
            autoFocus
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="scan" size="small">
                    <img src={imgBarcode} alt={t('alt.bar_code')} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box pr={2}>
          <Button
            onClick={handleAddVehicleIdDialogConfirmation}
            color="primary"
            sx={{ textTransform: 'uppercase' }}
          >
            {t('common.save')}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default AddVehicleIdDialog
